import { css } from '@emotion/react'
import { useNavigate } from 'react-router'
import { Col, Row, Title, Avatar, Button, Icon } from 'common-components'
import { Space } from 'antd'

import PercentTag from './PercentTag'

const Header = ({ data }) => {
  const navigate = useNavigate()
  const texts = [
    {
      type: 'tablePageTitle',
      content: `Anglais`,
    },
    {
      type: 'tablePageSubtitle',
      content: `Passé le 18 novembre 2023`,
    },
  ]

  return (
    <div>
      <Row
        justify={'space-between'}
        align={'top'}
        css={css`
          margin: 24px 0;
        `}
      >
        <Col>
          <Row justify={'center'} gutter={30} align={'middle'}>
            <Col>
              <Button
                size='sm'
                onClick={() => {
                  navigate(-1)
                }}
              >
                <Icon icon='ArrowNarrowLeft' size={20} />
              </Button>
            </Col>
            <Col>
              <Avatar src={data.urlAvatar} size='xl' />
            </Col>
            <Col>
              {texts.map((text, index) => {
                if (index === 0) {
                  return (
                    <Space align={'center'}>
                      <Title key={`title-${text.content}-${index}`} style={{ fontSize: 18 }}>
                        {text.content}
                      </Title>
                      <PercentTag withIcon={false} state='positive'>
                        85%
                      </PercentTag>
                    </Space>
                  )
                }
                return (
                  <Title key={`title-${text.content}-${index}`} preset={text.type as any}>
                    {text.content}
                  </Title>
                )
              })}
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  )
}

export default Header
